import { Pipe, PipeTransform } from '@angular/core';
import { ValidationErrors } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'joinErrorMessages',
  pure: false,
  standalone: true,
})
export class JoinErrorMessagesPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(
    errors: ValidationErrors | null,
    messages: ValidationErrors = {},
    omitKeys: string[] = []
  ): string {
    if (!errors) {
      return '';
    }

    return Object.keys(errors)
      .filter((key) => !omitKeys.includes(key))
      .map((key) => this.translate.instant(messages[key] || key, interpolationParams(errors, key)))
      .join(', ');
  }
}

function interpolationParams(errors: ValidationErrors, key: string): { value?: number } {
  const error = errors[key];
  if (key === 'min' && error?.min != null) {
    return { value: error.min };
  }

  if (key === 'max' && error?.max != null) {
    return { value: error.max };
  }

  return {};
}
